import React, { useRef } from "react";
import CustomButton from "../custom-button";

const Broucher = () => {
  const iframeRef = useRef(null);

  const printIframeContentAsPDF = () => {
    if (iframeRef.current) {
      const iframeWindow = iframeRef.current.contentWindow;

      iframeWindow.focus();
      iframeWindow.print();
    }
  };

  return (
    <div className="text-center section-spacing-top" style={{ fontFamily: "var(_alice)", marginBottom: "-55px" }}>
      {/* <button
        onClick={printIframeContentAsPDF}
        className="btn btn-primary section-spacing-top"
      >
        Download or Print
      </button> */}
      <CustomButton onClick={printIframeContentAsPDF} text={`Download or Print`}/>
      <p style={{ fontFamily: "var(_alice)" }} className="mb-4 broucherPTag">
        (Please select you native language from top-right corner)
      </p>
      <iframe
        ref={iframeRef}
        src="/Brochure2.html" // Replace with your iframe source
        title="Brochure"
        width="100%"
        style={{ height: "80vh" }}
      ></iframe>
    </div>
  );
};

export default React.memo(Broucher);
